import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export const TooltipHeader = ({ title, shouldHideBorder, }) => (_jsx("div", { className: classNames("cvr-tooltip-header-box", {
        "border-b-0": shouldHideBorder,
    }), children: _jsx("h2", { className: "text-lg font-medium", children: title }) }));
